import * as APPDATA from './pcConstAppData';

export const MAXIMUM_SEQUENCE = 10;

export const ChipTiming = {
  [APPDATA.KEY.DiaphragmTimingOpen]: 275,
  [APPDATA.KEY.DiaphragmTimingClose]: 275,
  [APPDATA.KEY.ValveTiming]: 25,
};
export const LowDiaphragmPressure = {
  [APPDATA.KEY.Default]: 20,
  [APPDATA.KEY.PreventLeaks]: 10,
};
export const SEQUENCE_TYPE_ALL_ENUM = {
  PRIME: {
    FE: 'PRIME',
    BE: 'prime',
  },
  PRIME_BY_SAMPLE: {
    FE: 'PRIME_BY_SAMPLE',
    BE: 'prime_by_sample',
  },
  CONCENTRATE: {
    FE: 'CONCENTRATE',
    BE: 'concentrate',
  },
  REVERSE_CONCENTRATE: {
    FE: 'REVERSE_CONCENTRATE',
    BE: 'reverse_concentrate',
  },
  DIAFILTRATE: {
    FE: 'DIAFILTRATE',
    BE: 'diafiltrate',
  },
  REVERSE_DIAFILTRATE: {
    FE: 'REVERSE_DIAFILTRATE',
    BE: 'reverse_diafiltrate',
  },
  BUFFER_RECOVERY: {
    FE: 'BUFFER_RECOVERY',
    BE: 'buffer_recovery',
  },
  PRESSURE_CHANGE: {
    FE: 'PRESSURE_CHANGE',
    BE: 'pressure_changes',
  },
  DEPRESSURIZED_PRESSURE: {
    FE: 'DEPRESSURIZED_PRESSURE',
    BE: 'depressurized',
  },
  AIR_RECOVERY: {
    FE: 'AIR_RECOVERY',
    BE: 'reverse_concentrate',
  },
  // MIXING FEATURE F.A.W.
  TUBE_MIXING: {
    FE: 'TUBE_MIXING',
    BE: 'tube_mixing',
  },
  // MIXING FEATURE F.A.W.
  RECIRCULATION: {
    FE: 'RECIRCULATION',
    BE: 'recirculate',
  },
};
export const SEQUENCE_TYPE_ALL = {
  [SEQUENCE_TYPE_ALL_ENUM.PRIME.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.PRIME.BE,
    label: 'PRIMING (BUFFER)',
  },
  [SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.BE,
    label: 'PRIMING (SAMPLE)',
  },
  [SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.BE,
    label: 'CONCENTRATING',
  },
  [SEQUENCE_TYPE_ALL_ENUM.REVERSE_CONCENTRATE.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.REVERSE_CONCENTRATE.BE,
    label: 'REVERSE CONCENTRATING',
  },
  [SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.BE,
    label: 'DIAFILTRATING',
  },
  [SEQUENCE_TYPE_ALL_ENUM.REVERSE_DIAFILTRATE.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.REVERSE_DIAFILTRATE.BE,
    label: 'REVERSE DIAFILTRATING',
  },
  [SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.BE,
    label: 'BUFFER RECOVERY',
  },
  [SEQUENCE_TYPE_ALL_ENUM.PRESSURE_CHANGE.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.PRESSURE_CHANGE.BE,
    label: 'PRESSURE CHANGE',
  },
  [SEQUENCE_TYPE_ALL_ENUM.DEPRESSURIZED_PRESSURE.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.DEPRESSURIZED_PRESSURE.BE,
    label: 'DEPRESSURIZED PRESSURE',
  },
  // MIXING FEATURE F.A.W.
  [SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.BE,
    label: 'TUBE MIXING',
  },
  // MIXING FEATURE F.A.W.
  [SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.BE,
    label: 'RECIRCULATION',
  },
};
export const SEQUENCE_TYPE = {
  [SEQUENCE_TYPE_ALL_ENUM.PRIME.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.PRIME.BE,
    label: 'PRIMING (BUFFER)',
  },
  [SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.BE,
    label: 'PRIMING (SAMPLE)',
  },
  [SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.BE,
    label: 'CONCENTRATING',
  },
  [SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.BE,
    label: 'BUFFER EXCHANGE',
  },
  [SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.BE,
    label: 'BUFFER RECOVERY',
  },
  [SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.BE,
    label: 'AIR RECOVERY',
  },
  // MIXING FEATURE F.A.W.
  [SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.BE,
    label: 'TUBE MIXING',
  },
  // MIXING FEATURE F.A.W.
  [SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.FE]: {
    value: SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.BE,
    label: 'RECIRCULATION',
  },
};
export const RUN_TIME_MODE = {
  TIMES: {
    NAME: '# OF PUMPS',
    NUMPAD_TITLE: 'Number of Pumps',
    VALUE: 'CYCLES',
    SIMPLE_NAME: 'PUMPS',
  },
  MINUTES: {
    NAME: 'MINUTES',
    NUMPAD_TITLE: 'Minutes',
    VALUE: 'MINUTES',
    SIMPLE_NAME: 'MINUTES',
  },
};

/**
 * @deprecated it was indicates the current device state, used {@link APPDATA.DEVICE_STATE} instead
 * @enum {String}
 */
export const STATUS_SEQUENCE_DESINGER = {
  IDLE: 'IDLE',
  RUNNING: 'RUNNING',
  PAUSED: 'PAUSED',
  DEPRESSURIZING: 'DEPRESSURIZING',
};

export const MANUAL_CONTROL_LOW_PRESSURE_ONLY = {
  [SEQUENCE_TYPE_ALL_ENUM.PRIME.FE]: SEQUENCE_TYPE_ALL_ENUM.PRIME.BE,
  [SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.FE]: SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.BE,
  [SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.FE]: SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.BE,
  [SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.FE]: SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.BE,
  [SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.FE]: SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.BE,
  // MIXING FEATURE F.A.W.
  [SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.FE]: SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.BE,
  // MIXING FEATURE F.A.W.
  [SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.FE]: SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.BE,
};
